import { chatService } from './chatService';
// Production emits one complete JSON result. Incremental events are an injectable fixture seam,
// not a claim that the existing HTTP server streams.
export const fullChatTransport = {
  async send({ message, chatId, signal, onEvent }) {
    onEvent?.({ type: 'start' });
    const data = await chatService.sendMessage(message, chatId, signal);
    if (!signal?.aborted) onEvent?.({ type: 'complete', data });
    return data;
  },
};
